export const menuCategories = [
  {
    id: 'ov-tailgating',
    slug: 'ov-tailgating',
    name: 'O.V. Tailgating',
    icon: 'ri-restaurant-line',
    description: 'Appetizers and starters',
    image: 'https://public.readdy.ai/ai/img_res/665799fa8f454457efcfe77919b1ce6a.jpg',
    items: [],
  },
  {
    id: 'fry-boats',
    slug: 'fry-boats',
    name: 'Fry Boats',
    icon: 'ri-bowl-line',
    description: 'Loaded fries with toppings',
    image: 'https://readdy.ai/api/search-image?query=Loaded%20french%20fries%20boats%20with%20various%20toppings%20cheese%20steak%20truffle%20parmesan%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=102&orientation=landscape',
    items: [],
  },
  {
    id: 'wings',
    slug: 'wings',
    name: 'Wings',
    icon: 'ri-cake-2-line',
    description: 'Marinated and fried wings',
    image: 'https://readdy.ai/api/search-image?query=Crispy%20chicken%20wings%20with%20various%20sauces%20buffalo%20bbq%20garlic%20parmesan%20served%20with%20celery%20ranch%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=103&orientation=landscape',
    items: [],
  },
  {
    id: 'quesadillas',
    slug: 'quesadillas',
    name: 'Quesadillas',
    icon: 'ri-cake-line',
    description: 'Grilled flour tortilla quesadillas',
    image: 'https://readdy.ai/api/search-image?query=Grilled%20quesadillas%20with%20chicken%20steak%20shrimp%20cheese%20salsa%20sour%20cream%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=104&orientation=landscape',
    items: [],
  },
  {
    id: 'lighter-fare',
    slug: 'lighter-fare',
    name: 'Lighter Fare',
    icon: 'ri-plant-line',
    description: 'Salads and lighter options',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20salads%20greek%20wedge%20house%20salad%20with%20vegetables%20cheese%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=105&orientation=landscape',
    items: [],
  },
  {
    id: 'steak-seafood',
    slug: 'steak-seafood',
    name: 'Steak & Seafood',
    icon: 'ri-fish-line',
    description: 'Premium steaks and seafood dishes',
    image: 'https://readdy.ai/api/search-image?query=Grilled%20New%20York%20strip%20steak%20shrimp%20pasta%20mahi%20mahi%20with%20rice%20vegetables%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=106&orientation=landscape',
    items: [],
  },
  {
    id: 'burgers',
    slug: 'burgers',
    name: 'Burgers',
    icon: 'ri-restaurant-2-line',
    description: 'Hand-made fresh to order. Comes w/ chips, fries, or coleslaw. Upgrade to premium side for $3 or Truffle Parm Fries for $6.',
    image: 'https://readdy.ai/api/search-image?query=Gourmet%20burger%20selection%20with%20melted%20cheese%20lettuce%20tomato%20on%20brioche%20buns%20double%20smash%20burgers%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=107&orientation=landscape',
    items: [],
  },
  {
    id: 'sandwiches',
    slug: 'sandwiches',
    name: 'Between the Bread',
    icon: 'ri-file-list-line',
    description: 'Comes w/ chips, fries or coleslaw. Upgrade to premium side for $3 or Truffle Parm Fries for $6.',
    image: 'https://readdy.ai/api/search-image?query=Gourmet%20sandwich%20selection%20BLT%20gyro%20wraps%20fish%20sandwiches%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=108&orientation=landscape',
    items: [],
  },
  {
    id: 'baskets',
    slug: 'baskets',
    name: 'Baskets',
    icon: 'ri-shopping-basket-line',
    description: 'Baskets come w/ fries, lemon, coleslaw, and homemade cocktail or key-lime tartar sauce.',
    image: 'https://readdy.ai/api/search-image?query=Fried%20fish%20basket%20with%20french%20fries%20coleslaw%20lemon%20cocktail%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=109&orientation=landscape',
    items: [],
  },
  {
    id: 'sides-desserts',
    slug: 'sides-desserts',
    name: 'Sides N\' Desserts',
    icon: 'ri-cake-3-line',
    description: 'Regular and premium sides plus desserts',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20side%20dishes%20sweet%20potato%20fries%20onion%20rings%20coleslaw%20french%20fries%20key%20lime%20pie%20dessert%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=110&orientation=landscape',
    items: [],
  },
  {
    id: 'ov-dranks',
    slug: 'ov-dranks',
    name: 'O.V. Dranks',
    icon: 'ri-goblet-line',
    description: 'Signature cocktails and drinks',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20signature%20cocktails%20martini%20aperol%20spritz%20rum%20punch%20margarita%20on%20bar%20counter%20tropical%20Florida%20Keys%20atmosphere%20professional%20photography%20clean%20background&width=800&height=600&seq=111&orientation=landscape',
    items: [],
  },
  {
    id: 'spirits',
    slug: 'spirits',
    name: 'Spirits',
    icon: 'ri-wine-line',
    description: 'Vodka, Rum, Whiskey, Bourbon, Gin, Scotch & Tequila',
    image: 'https://readdy.ai/api/search-image?query=Premium%20spirits%20bottles%20vodka%20rum%20whiskey%20bourbon%20gin%20scotch%20tequila%20on%20bar%20shelf%20professional%20photography%20clean%20background%20bar%20atmosphere&width=800&height=600&seq=112&orientation=landscape',
    items: [],
  },
];

export const menuItems = {
  'ov-tailgating': [
    {
      name: 'Macho Nachos',
      slug: 'macho-nachos',
      price: 15.95,
      description: 'Fresh homemade tortilla chips with Larz\'s chili, nacho cheese, jalapeños, sour cream, lettuce, and fire-roasted salsa. Add guacamole for $3.',
      image: 'https://readdy.ai/api/search-image?query=Loaded%20nachos%20with%20chili%20nacho%20cheese%20jalapenos%20sour%20cream%20lettuce%20salsa%20on%20fresh%20tortilla%20chips%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=201&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Seared Tuna',
      slug: 'seared-tuna',
      price: 17.95,
      description: 'Sushi-grade Ahi tuna, blackened and seared, served with wakame salad, ginger, lemon, fresh wasabi, and soy sauce.',
      image: 'https://readdy.ai/api/search-image?query=Seared%20ahi%20tuna%20blackened%20with%20wakame%20seaweed%20salad%20ginger%20wasabi%20soy%20sauce%20lemon%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=202&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Peel & Eat',
      slug: 'peel-eat',
      price: 18.95,
      description: 'Flash-boiled seafood in Old Bay and lemons, served chilled with homemade cocktail sauce.',
      image: 'https://readdy.ai/api/search-image?query=Peel%20and%20eat%20shrimp%20boiled%20with%20old%20bay%20seasoning%20lemons%20served%20chilled%20with%20cocktail%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=203&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Mini Corn Dogs',
      slug: 'mini-corn-dogs',
      price: 11.95,
      description: 'Battered mini Nathan\'s hot dogs, served with honey-mustard dipping sauce (10 per order).',
      image: 'https://readdy.ai/api/search-image?query=Mini%20corn%20dogs%20battered%20nathans%20hot%20dogs%20with%20honey%20mustard%20dipping%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=204&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Smoked Fish Dip',
      slug: 'smoked-fish-dip',
      price: 15.95,
      description: 'Served with homemade tortilla chips, crackers, and celery.',
      image: 'https://readdy.ai/api/search-image?query=Smoked%20fish%20dip%20spread%20with%20tortilla%20chips%20crackers%20celery%20sticks%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=205&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Dolphin Fingers',
      slug: 'dolphin-fingers',
      price: 11.95,
      description: 'Mahi Mahi fingers, blackened or fried, with homemade key-lime tartar sauce and lemon wedge.',
      image: 'https://readdy.ai/api/search-image?query=Mahi%20mahi%20fish%20fingers%20blackened%20or%20fried%20with%20key%20lime%20tartar%20sauce%20lemon%20wedge%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=206&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Conch Ceviche',
      slug: 'conch-ceviche',
      price: 14.95,
      description: 'Bahamian conch marinated in lime juice with onions, tomatoes, cilantro, and peppers, served with tortilla chips and crackers.',
      image: 'https://readdy.ai/api/search-image?query=Conch%20ceviche%20marinated%20in%20lime%20juice%20with%20onions%20tomatoes%20cilantro%20peppers%20served%20with%20tortilla%20chips%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=207&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Conch Fritters',
      slug: 'conch-fritters',
      price: 15.95,
      description: 'Golden-fried conch fritters with island spices, served with firecracker dipping sauce.',
      image: 'https://readdy.ai/api/search-image?query=Golden%20fried%20conch%20fritters%20with%20island%20spices%20firecracker%20dipping%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=208&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Chicken Fingers',
      slug: 'chicken-fingers',
      price: 13.95,
      description: 'Freshly handmade crispy breaded chicken served with honey-mustard dipping sauce.',
      image: 'https://readdy.ai/api/search-image?query=Crispy%20breaded%20chicken%20fingers%20tenders%20with%20honey%20mustard%20dipping%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=209&orientation=landscape',
      category: 'ov-tailgating',
    },
    {
      name: 'Buffalo Shrimp',
      slug: 'buffalo-shrimp',
      price: 14.95,
      description: 'Six crispy fried shrimp tossed in buffalo sauce, served with celery and bleu cheese or ranch.',
      image: 'https://readdy.ai/api/search-image?query=Crispy%20fried%20shrimp%20tossed%20in%20buffalo%20sauce%20with%20celery%20sticks%20blue%20cheese%20ranch%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=210&orientation=landscape',
      category: 'ov-tailgating',
    },
  ],
  'fry-boats': [
    {
      name: 'Greek Boat',
      slug: 'greek-boat',
      price: 13.95,
      description: 'Fries topped with tzatziki, feta, red onions, and dill.',
      image: 'https://readdy.ai/api/search-image?query=Loaded%20french%20fries%20topped%20with%20tzatziki%20sauce%20feta%20cheese%20red%20onions%20fresh%20dill%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=301&orientation=landscape',
      category: 'fry-boats',
    },
    {
      name: 'Philly Steak',
      slug: 'philly-steak',
      price: 13.95,
      description: 'Fries topped with roast sirloin, cheese sauce, and grilled onions.',
      image: 'https://readdy.ai/api/search-image?query=Loaded%20french%20fries%20topped%20with%20roast%20sirloin%20steak%20cheese%20sauce%20grilled%20onions%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=302&orientation=landscape',
      category: 'fry-boats',
    },
    {
      name: 'Truffle Parm',
      slug: 'truffle-parm',
      price: 14.95,
      description: 'Fries topped with truffle oil, fresh parmesan, and parsley.',
      image: 'https://readdy.ai/api/search-image?query=Loaded%20french%20fries%20topped%20with%20truffle%20oil%20fresh%20parmesan%20cheese%20parsley%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=303&orientation=landscape',
      category: 'fry-boats',
    },
    {
      name: 'N.Y. Cilantro-Lime',
      slug: 'ny-cilantro-lime',
      price: 17.95,
      description: 'Fries topped with N.Y. strip, cilantro-lime crema, and parmesan.',
      image: 'https://readdy.ai/api/search-image?query=Loaded%20french%20fries%20topped%20with%20New%20York%20strip%20steak%20cilantro%20lime%20crema%20parmesan%20cheese%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=304&orientation=landscape',
      category: 'fry-boats',
    },
  ],
  wings: [
    {
      name: '6 Wings',
      slug: '6-wings',
      price: 13.95,
      description: 'Marinated 24 hours, baked then fried. Flavors: Plain, Lemon-Pepper, Garlic-Parm, BBQ, Thai-Chili, Buffalo, Dry Cajun, Hot. Served with celery and bleu cheese or ranch.',
      image: 'https://readdy.ai/api/search-image?query=Six%20crispy%20chicken%20wings%20with%20various%20sauce%20options%20served%20with%20celery%20sticks%20blue%20cheese%20ranch%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=401&orientation=landscape',
      category: 'wings',
    },
    {
      name: '12 Wings',
      slug: '12-wings',
      price: 18.95,
      description: 'Marinated 24 hours, baked then fried. Flavors: Plain, Lemon-Pepper, Garlic-Parm, BBQ, Thai-Chili, Buffalo, Dry Cajun, Hot. Served with celery and bleu cheese or ranch.',
      image: 'https://readdy.ai/api/search-image?query=Twelve%20crispy%20chicken%20wings%20with%20various%20sauce%20options%20served%20with%20celery%20sticks%20blue%20cheese%20ranch%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=402&orientation=landscape',
      category: 'wings',
    },
  ],
  quesadillas: [
    {
      name: 'Marinated Chicken Quesadilla',
      slug: 'marinated-chicken-quesadilla',
      price: 14,
      description: 'Grilled flour tortilla stuffed with cheddar cheese, fire-roasted salsa and sour cream.',
      image: 'https://readdy.ai/api/search-image?query=Grilled%20chicken%20quesadilla%20with%20cheddar%20cheese%20fire%20roasted%20salsa%20sour%20cream%20on%20flour%20tortilla%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=501&orientation=landscape',
      category: 'quesadillas',
    },
    {
      name: 'Steak Quesadilla',
      slug: 'steak-quesadilla',
      price: 17,
      description: 'Grilled flour tortilla stuffed with cheddar cheese, fire-roasted salsa and sour cream.',
      image: 'https://readdy.ai/api/search-image?query=Grilled%20steak%20quesadilla%20with%20cheddar%20cheese%20fire%20roasted%20salsa%20sour%20cream%20on%20flour%20tortilla%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=502&orientation=landscape',
      category: 'quesadillas',
    },
    {
      name: 'Blackened Shrimp Quesadilla',
      slug: 'blackened-shrimp-quesadilla',
      price: 17,
      description: 'Grilled flour tortilla stuffed with cheddar cheese, fire-roasted salsa and sour cream.',
      image: 'https://readdy.ai/api/search-image?query=Blackened%20shrimp%20quesadilla%20with%20cheddar%20cheese%20fire%20roasted%20salsa%20sour%20cream%20on%20flour%20tortilla%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=503&orientation=landscape',
      category: 'quesadillas',
    },
  ],
  'lighter-fare': [
    {
      name: 'The Greek Salad',
      slug: 'the-greek-salad',
      price: 12.95,
      description: 'Iceberg, tomato, red onion, green pepper, feta crumbles & Greek dressing.',
      image: 'https://readdy.ai/api/search-image?query=Greek%20salad%20with%20iceberg%20lettuce%20tomatoes%20red%20onions%20green%20peppers%20feta%20cheese%20greek%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=601&orientation=landscape',
      category: 'lighter-fare',
    },
    {
      name: 'The Wedge',
      slug: 'the-wedge',
      price: 12.95,
      description: 'Iceberg wedge with bacon, cucumbers, cherry tomatoes, and bleu cheese crumbles.',
      image: 'https://readdy.ai/api/search-image?query=Wedge%20salad%20with%20iceberg%20lettuce%20bacon%20cucumbers%20cherry%20tomatoes%20blue%20cheese%20crumbles%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=602&orientation=landscape',
      category: 'lighter-fare',
    },
    {
      name: 'The House Salad',
      slug: 'the-house-salad',
      price: 11.95,
      description: 'Iceberg & mixed greens, tomatoes, cucumbers, onions, carrots, shredded cheese, and croutons.',
      image: 'https://readdy.ai/api/search-image?query=House%20salad%20with%20iceberg%20mixed%20greens%20tomatoes%20cucumbers%20onions%20carrots%20shredded%20cheese%20croutons%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=603&orientation=landscape',
      category: 'lighter-fare',
    },
    {
      name: 'Larz\'s Chili',
      slug: 'larzs-chili',
      price: 6.95,
      description: 'Served with shredded cheese and diced onions.',
      image: 'https://readdy.ai/api/search-image?query=Bowl%20of%20homemade%20chili%20topped%20with%20shredded%20cheese%20diced%20onions%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=604&orientation=landscape',
      category: 'lighter-fare',
    },
  ],
  'steak-seafood': [
    {
      name: 'Spicy N.Y. Truffle Penne',
      slug: 'spicy-ny-truffle-penne',
      price: 39.95,
      description: '8oz N.Y. strip, penne pasta, cheese sauce, red pepper flakes, truffle oil, parsley.',
      image: 'https://readdy.ai/api/search-image?query=New%20York%20strip%20steak%20with%20penne%20pasta%20cheese%20sauce%20red%20pepper%20flakes%20truffle%20oil%20parsley%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=701&orientation=landscape',
      category: 'steak-seafood',
    },
    {
      name: 'N.Y. Strip',
      slug: 'ny-strip',
      price: 31.95,
      description: 'Flame grilled N.Y. strip, garlic herb butter, jasmine rice, crispy green beans.',
      image: 'https://readdy.ai/api/search-image?query=Flame%20grilled%20New%20York%20strip%20steak%20with%20garlic%20herb%20butter%20jasmine%20rice%20crispy%20green%20beans%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=702&orientation=landscape',
      category: 'steak-seafood',
    },
    {
      name: 'Voodoo Shrimp',
      slug: 'voodoo-shrimp',
      price: 23.95,
      description: 'Cajun jumbo shrimp, spicy marinara, linguine, lemon wedges.',
      image: 'https://readdy.ai/api/search-image?query=Cajun%20jumbo%20shrimp%20in%20spicy%20marinara%20sauce%20over%20linguine%20pasta%20with%20lemon%20wedges%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=703&orientation=landscape',
      category: 'steak-seafood',
    },
    {
      name: 'Cilantro-Lime Mahi',
      slug: 'cilantro-lime-mahi',
      price: 22.95,
      description: 'Blackened, grilled or fried mahi on jasmine rice with green beans and cilantro-lime crema.',
      image: 'https://readdy.ai/api/search-image?query=Blackened%20mahi%20mahi%20fish%20on%20jasmine%20rice%20with%20green%20beans%20cilantro%20lime%20crema%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=704&orientation=landscape',
      category: 'steak-seafood',
    },
  ],
  burgers: [
    {
      name: 'O.V. Classic',
      slug: 'ov-classic',
      price: 14.95,
      description: 'The Original Fatburger with Lettuce, Tomato, Onions, Pickles, and choice of Cheese on a Toasted Brioche Bun.',
      image: 'https://readdy.ai/api/search-image?query=Classic%20fatburger%20with%20lettuce%20tomato%20onions%20pickles%20cheese%20on%20toasted%20brioche%20bun%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=801&orientation=landscape',
      category: 'burgers',
    },
    {
      name: 'Simply Smashed',
      slug: 'simply-smashed',
      price: 14.95,
      description: 'Double Smashburger, double cheese, grilled onions, and our signature O.V. sauce on a toasted bun.',
      image: 'https://readdy.ai/api/search-image?query=Double%20smashed%20burger%20with%20double%20cheese%20grilled%20onions%20special%20sauce%20on%20toasted%20bun%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=802&orientation=landscape',
      category: 'burgers',
    },
    {
      name: 'Memphis Crunch',
      slug: 'memphis-crunch',
      price: 17.95,
      description: 'Double Smash Burger, Bacon, BBQ sauce, Double Cheddar, Crispy Onion straws on Brioche.',
      image: 'https://readdy.ai/api/search-image?query=Double%20smash%20burger%20with%20bacon%20BBQ%20sauce%20double%20cheddar%20cheese%20crispy%20onion%20straws%20on%20bun%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=803&orientation=landscape',
      category: 'burgers',
    },
    {
      name: 'The Krakatoa',
      slug: 'the-krakatoa',
      price: 18.95,
      description: 'Double Smashburger, O.V. sauce, Grilled Jalapenos, Bacon & Melted Pepper-Jack Cheese on a Brioche Bun.',
      image: 'https://readdy.ai/api/search-image?query=Spicy%20double%20smash%20burger%20with%20chipotle%20mayo%20grilled%20jalapenos%20crispy%20bacon%20pepper%20jack%20cheese%20on%20bun%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=804&orientation=landscape',
      category: 'burgers',
    },
  ],
  sandwiches: [
    {
      name: 'B.B.B.L.T.',
      slug: 'bbblt',
      price: 14.95,
      description: 'Triple bacon sandwich, lettuce, tomatoes, mayo on white bread.',
      image: 'https://readdy.ai/api/search-image?query=Triple%20bacon%20BLT%20sandwich%20with%20fresh%20lettuce%20tomatoes%20mayo%20on%20white%20bread%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=901&orientation=landscape',
      category: 'sandwiches',
    },
    {
      name: 'The Gyro',
      slug: 'the-gyro',
      price: 16.95,
      description: 'Rotisserie lamb and beef, Lettuce, Tomato, Red onions, Feta Crumbles and Tzatziki in a pita.',
      image: 'https://readdy.ai/api/search-image?query=Greek%20gyro%20wrap%20with%20rotisserie%20lamb%20beef%20lettuce%20tomato%20red%20onions%20feta%20tzatziki%20in%20pita%20bread%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=902&orientation=landscape',
      category: 'sandwiches',
    },
    {
      name: 'Marinated CBR Wrap',
      slug: 'marinated-cbr-wrap',
      price: 15.95,
      description: 'Marinated chicken, bacon, cheese, lettuce, tomatoes, ranch and flour tortilla. Available blackened, grilled, or fried. Original or Buffalo style +$0.75.',
      image: 'https://readdy.ai/api/search-image?query=Chicken%20bacon%20ranch%20wrap%20with%20lettuce%20tomatoes%20cheese%20in%20flour%20tortilla%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=903&orientation=landscape',
      category: 'sandwiches',
    },
    {
      name: 'Dolphin Rueben',
      slug: 'dolphin-rueben',
      price: 17.95,
      description: 'Signature Sandwich: Grilled or Blackened Mahi Mahi on rye with Swiss cheese, coleslaw, and Thousand Island dressing.',
      image: 'https://readdy.ai/api/search-image?query=Mahi%20mahi%20reuben%20sandwich%20on%20rye%20bread%20with%20swiss%20cheese%20coleslaw%20thousand%20island%20dressing%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=904&orientation=landscape',
      category: 'sandwiches',
    },
    {
      name: 'Dolphin Sandy',
      slug: 'dolphin-sandy',
      price: 16.95,
      description: 'Mahi Mahi Blackened, grilled or Fried, Lettuce, Tomato, Onion, toasted Brioche Bun.',
      image: 'https://readdy.ai/api/search-image?query=Mahi%20mahi%20fish%20sandwich%20blackened%20grilled%20fried%20with%20lettuce%20tomato%20onion%20on%20toasted%20brioche%20bun%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=905&orientation=landscape',
      category: 'sandwiches',
    },
    {
      name: 'Steak Supreme',
      slug: 'steak-supreme',
      price: 16.95,
      description: 'Roasted sirloin, Grilled Onions, Peppers, provolone cheese. Sub Homemade cheese sauce +$1.',
      image: 'https://readdy.ai/api/search-image?query=Steak%20sandwich%20with%20roasted%20sirloin%20grilled%20onions%20peppers%20provolone%20cheese%20on%20toasted%20roll%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=906&orientation=landscape',
      category: 'sandwiches',
    },
  ],
  baskets: [
    {
      name: 'Dolphin Basket',
      slug: 'dolphin-basket',
      price: 20.95,
      description: 'Over 1/2 lb of mahi filets. A local favorite.',
      image: 'https://readdy.ai/api/search-image?query=Fried%20mahi%20mahi%20fish%20basket%20with%20french%20fries%20coleslaw%20lemon%20cocktail%20sauce%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1001&orientation=landscape',
      category: 'baskets',
    },
    {
      name: 'Shrimp Basket',
      slug: 'shrimp-basket',
      price: 23.95,
      description: '10 Jumbo sized crispy fried shrimp over a bed of crispy fries.',
      image: 'https://readdy.ai/api/search-image?query=Crispy%20fried%20jumbo%20shrimp%20basket%20with%20french%20fries%20coleslaw%20cocktail%20sauce%20lemon%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1002&orientation=landscape',
      category: 'baskets',
    },
    {
      name: 'Cook Your Catch',
      slug: 'cook-your-catch',
      price: 15,
      description: 'Up to 1 lb of fish per person. Blackened Grilled or Fried, 1 order of fries and sauce of choice per person.',
      image: 'https://readdy.ai/api/search-image?query=Fresh%20catch%20fish%20cooked%20blackened%20grilled%20fried%20with%20fries%20sauce%20Florida%20Keys%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1003&orientation=landscape',
      category: 'baskets',
    },
  ],
  'sides-desserts': [
    {
      name: 'Regular Sides',
      slug: 'regular-sides',
      price: 4.95,
      description: 'Choose from: Coleslaw, French Fries, Pasta Salad, House Salad, or G&H Green Beans.',
      image: 'https://readdy.ai/api/search-image?query=Assorted%20regular%20side%20dishes%20coleslaw%20french%20fries%20pasta%20salad%20house%20salad%20green%20beans%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1101&orientation=landscape',
      category: 'sides-desserts',
    },
    {
      name: 'Premium Sides',
      slug: 'premium-sides',
      price: 7.95,
      description: 'Choose from: Sweet Potato Fries, Onion Rings, Fried Green Beans, Fried Pickle Chips, or Penne N\' Cheese.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20side%20dishes%20sweet%20potato%20fries%20onion%20rings%20fried%20green%20beans%20fried%20pickle%20chips%20penne%20cheese%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1102&orientation=landscape',
      category: 'sides-desserts',
    },
    {
      name: 'Key-Lime Pie Popsicle',
      slug: 'key-lime-pie-popsicle',
      price: 9.95,
      description: 'Classic Florida Keys key-lime pie popsicle — a refreshing frozen treat.',
      image: 'https://readdy.ai/api/search-image?query=Key%20lime%20pie%20popsicle%20frozen%20dessert%20Florida%20Keys%20tropical%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1103&orientation=landscape',
      category: 'sides-desserts',
    },
    {
      name: 'Triple Chocolate Cake',
      slug: 'triple-chocolate-cake',
      price: 9.95,
      description: 'Rich and decadent triple chocolate layer cake.',
      image: 'https://readdy.ai/api/search-image?query=Triple%20chocolate%20layer%20cake%20rich%20decadent%20dessert%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1104&orientation=landscape',
      category: 'sides-desserts',
    },
    {
      name: 'Authentic Key-Lime Pie',
      slug: 'authentic-key-lime-pie',
      price: 9.95,
      description: 'Classic authentic Florida Keys key-lime pie.',
      image: 'https://readdy.ai/api/search-image?query=Authentic%20Florida%20Keys%20key%20lime%20pie%20slice%20creamy%20tart%20dessert%20restaurant%20quality%20food%20photography%20clean%20white%20background%20professional%20lighting%20appetizing%20presentation&width=800&height=600&seq=1105&orientation=landscape',
      category: 'sides-desserts',
    },
  ],
  'ov-dranks': [
    {
      name: 'Ex-spresso Martini',
      slug: 'ex-spresso-martini',
      price: 13.95,
      description: 'Borghetti Espresso liqueur w/ absolute vanilla.',
      image: 'https://readdy.ai/api/search-image?query=Espresso%20martini%20cocktail%20with%20coffee%20liqueur%20vanilla%20vodka%20in%20elegant%20martini%20glass%20professional%20bar%20photography%20clean%20dark%20background&width=800&height=600&seq=1201&orientation=landscape',
      category: 'ov-dranks',
    },
    {
      name: 'Aperol Spritz',
      slug: 'aperol-spritz',
      price: 12.95,
      description: 'Aperol, prosecco, soda.',
      image: 'https://readdy.ai/api/search-image?query=Aperol%20spritz%20cocktail%20with%20prosecco%20soda%20orange%20slice%20in%20wine%20glass%20professional%20bar%20photography%20clean%20background%20tropical%20atmosphere&width=800&height=600&seq=1202&orientation=landscape',
      category: 'ov-dranks',
    },
    {
      name: 'Magic-Rita',
      slug: 'magic-rita',
      price: 11.95,
      description: 'Milagro Silver, Triple Sec, First Pressed Lime — add Gran Mariner Floater +$4.',
      image: 'https://readdy.ai/api/search-image?query=Margarita%20cocktail%20with%20silver%20tequila%20triple%20sec%20fresh%20lime%20juice%20salt%20rim%20glass%20professional%20bar%20photography%20clean%20background%20tropical%20Florida%20Keys&width=800&height=600&seq=1203&orientation=landscape',
      category: 'ov-dranks',
    },
    {
      name: 'O.V. Rum Punch',
      slug: 'ov-rum-punch',
      price: 11.95,
      description: 'Capt Morgan Private stock, fruit juice blend — ADD 151 floater +$3.',
      image: 'https://readdy.ai/api/search-image?query=Tropical%20rum%20punch%20cocktail%20with%20Captain%20Morgan%20fruit%20juice%20blend%20in%20tall%20glass%20professional%20bar%20photography%20clean%20background%20Florida%20Keys%20tropical&width=800&height=600&seq=1204&orientation=landscape',
      category: 'ov-dranks',
    },
    {
      name: 'The MULE',
      slug: 'the-mule',
      price: 10.95,
      description: 'Tito\'s, Barrit\'s ginger beer, lime juice.',
      image: 'https://readdy.ai/api/search-image?query=Moscow%20mule%20cocktail%20with%20vodka%20ginger%20beer%20lime%20juice%20in%20copper%20mug%20professional%20bar%20photography%20clean%20background&width=800&height=600&seq=1205&orientation=landscape',
      category: 'ov-dranks',
    },
  ],
  spirits: [
    {
      name: 'Vodka',
      slug: 'vodka',
      price: 0,
      description: 'Absolut, Absolut Vanilla, 3 Olives Cherry, 3 Olives Grape, D.E. Grapefruit, D.E. Lemon, D.E. Orange, D.E. Peach, D.E. Ruby Red, D.E. Sweet Tea, Islamorada – I.B.C. Vodka, Grey Goose, Ketel One, Smirnoff, Stoli, Stoli 0, Svedka Razz, Tito\'s.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20vodka%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1301&orientation=landscape',
      category: 'spirits',
    },
    {
      name: 'Rum',
      slug: 'rum',
      price: 0,
      description: 'Appleton Estate, Bacardi, Bacardi Black, Bacardi Limon, Capt Morgan, Capt Morgan Priv., Mt. Gay Eclipse, Malibu, Myers.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20rum%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1302&orientation=landscape',
      category: 'spirits',
    },
    {
      name: 'Whiskey / Bourbon',
      slug: 'whiskey-bourbon',
      price: 0,
      description: 'Bulleit, Canadian Club, Crown Royal, Fireball, Jack Daniels, Jameson, Jim Beam, Makers Mark, Seagrams 7, Skrewball, Southern Comfort, Wild Turkey, Woodford Reserve.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20whiskey%20bourbon%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1303&orientation=landscape',
      category: 'spirits',
    },
    {
      name: 'Gin',
      slug: 'gin',
      price: 0,
      description: 'Beefeaters, Bombay, Tanqueray.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20gin%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1304&orientation=landscape',
      category: 'spirits',
    },
    {
      name: 'Scotch',
      slug: 'scotch',
      price: 0,
      description: 'Chivas, Dewars, J.W. Black, J.W. Red.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20scotch%20whisky%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1305&orientation=landscape',
      category: 'spirits',
    },
    {
      name: 'Tequila',
      slug: 'tequila',
      price: 0,
      description: 'Casamigos, Casamigos Reposado, Cuervo 1800, Milagro, Patron, Dulce Vida Pineapple, Don Julio 1942.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20tequila%20bottles%20selection%20bar%20display%20professional%20photography%20clean%20background&width=800&height=600&seq=1306&orientation=landscape',
      category: 'spirits',
    },
  ],
};

// Populate items in menuCategories
menuCategories[0].items = menuItems['ov-tailgating'];
menuCategories[1].items = menuItems['fry-boats'];
menuCategories[2].items = menuItems.wings;
menuCategories[3].items = menuItems.quesadillas;
menuCategories[4].items = menuItems['lighter-fare'];
menuCategories[5].items = menuItems['steak-seafood'];
menuCategories[6].items = menuItems.burgers;
menuCategories[7].items = menuItems.sandwiches;
menuCategories[8].items = menuItems.baskets;
menuCategories[9].items = menuItems['sides-desserts'];
menuCategories[10].items = menuItems['ov-dranks'];
menuCategories[11].items = menuItems.spirits;

// Export menuData for the menu page
export const menuData = menuCategories;
